module.exports = __webpack_public_path__ + "img/pain-level-colored.bf1ac21c.svg";